import { stateOptions } from '../commonStateTaxData';

export const step1Questions = [
  {
    id: 'employee_name',
    title: 'Full name',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employee_ssn',
    title: 'Social Security number',
    is_required: true,
    placeholder: '9 digits',
    question_type: 'identity',
    identity_type: 'ssn',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{9}$',
      },
    ],
  },
  {
    id: 'street_address',
    title: 'Home address',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'city_or_town',
    title: 'City or town',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'state',
    title: 'State',
    is_required: true,
    question_type: 'dropdown',
    options: stateOptions,
  },
  {
    id: 'zip_code',
    title: 'Zip code',
    is_required: true,
    question_type: 'short_text',
    placeholder: '5 digits',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{5}$',
      },
    ],
  },
  {
    id: 'filing_status',
    title: 'Marital status:',
    is_required: true,
    question_type: 'long_multiple_choice',
    options: [
      {
        codeValue: 'single',
        shortName: 'Single',
      },
      {
        codeValue: 'married',
        shortName: 'Married',
      },
      {
        codeValue: 'married_withold_at_higher_single_rate',
        shortName: 'Married, but withhold at higher single rate',
      },
      {
        codeValue: 'certified_disabled_person',
        shortName: 'Certified disabled person (not subject to withholding)',
      },
      {
        codeValue: 'non_resident_military_spouse',
        shortName: 'Nonresident military spouse (not subject to withholding)',
      },
    ],
  },
];

export const worksheetQuestions = [
  {
    id: 'claim_for_age',
    title: 'You may claim an additional withholding allowance for age if you are at least 65 years old and no one can claim you as a dependent. If you are married and filing a joint return, you may also claim an additional withholding allowance if your spouse is at least 65 years old, no one else can claim your spouse as dependent, and your spouse is not already claiming such withholding allowance for himself / herself on a Form HW-4.',
    question_type: 'multiple_choice',
    options: [
      {
        codeValue: 'claim_for_age_1',
        shortName: 'If only one of you or your spouse qualify',
      },
      {
        codeValue: 'claim_for_age_2',
        shortName: 'If both you and your spouse qualify',
      },
      {
        codeValue: 'not_applicable',
        shortName: 'Not applicable',
      },
    ],
  },
  {
    id: 'dependents',
    title: 'Allowance(s) for your dependents, not including yourself or your spouse:',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
      {
        value: '100',
        action: 'lte',
        category: 'number',
      },
    ],
  },
  {
    id: 'itemize_or_claim_adjustments',
    title: 'If you plan to itemize or claim adjustments to income, complete the deductions and adjustment worksheet on Form HW-4 and enter the number of withholding allowances from line 8:',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
    ],
  },
];

export const additionalAmountInitialQuestion = [
  {
    id: 'additional_amount',
    title: 'Additional amount, if any, you want deducted each pay period:',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^[0-9]+(.[0-9]{1,2})?$',
      },
    ],
  },
];
